export default __webpack_public_path__ + "static/media/us2.6dd540e8.jpg";